export default "__VITE_ASSET__DDH1BwM0__"